/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/deleted_invoice'
export default icon
